import {
  Box,
  Flex,
  HStack,
  IconButton,
  useDisclosure,
  VStack,
  Text,
  Button,
  Image,
  Link,
  Icon,
} from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import { FiDollarSign, FiLogIn, FiUserPlus } from 'react-icons/fi';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import { getData } from '../../services/storage';
import SideDrawerBar from './SideDrawerBar';
import logo from '../../assets/logo.png';
import { useOutsideClick } from '@chakra-ui/react';

const Navbar = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState<string | number | undefined>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { orgId } = useParams();

  // One wrapper ref for BOTH the button and the menu
  const menuWrapperRef = useRef<HTMLDivElement>(null);

  useOutsideClick({
    ref: menuWrapperRef,
    handler: () => {
      if (isOpen) onClose();
    },
  });

  const handleMenuClose = () => {
    onClose();
  };

  const handleMenuOpen = () => {
    if (!isOpen) onOpen();
  };

  // Close menu on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (isOpen) onClose();
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isOpen, onClose]);

  useEffect(() => {
    const fetchInfo = async () => {
      let token = await getData('access_token');
      if (token) {
        setIsLoggedIn(token);
      }
    };
    fetchInfo();
  }, []);

  // Reusable option component
  const MobileMenuItem = ({
    label,
    icon,
    action,
  }: {
    label: string;
    icon: any;
    action: () => void;
  }) => (
    <HStack
      w="100%"
      px={6}
      py={3}
      spacing={3}
      onClick={() => {
        action();
        onClose();
      }}
      _hover={{ bg: 'gray.50', cursor: 'pointer' }}
      transition="0.2s"
    >
      <Icon as={icon} boxSize={5} color="gray.600" />
      <Text fontWeight="medium" fontSize="md">
        {label}
      </Text>
    </HStack>
  );

  return (
    <>
      <Box
        bg="white"
        px={4}
        boxShadow="sm"
        position="fixed"
        w="100%"
        zIndex={10}
      >
        <Flex h={16} alignItems="center" justifyContent="space-between">
          {isLoggedIn && <SideDrawerBar />}

          <Link href={'/'}>
            <Image src={logo} w={50} ml={6} />
          </Link>

          {/* Mobile toggle + menu wrapper */}
          {/* <Box ref={menuWrapperRef} display={{ md: 'none' }}> */}

          {!isLoggedIn && isOpen && (
            <IconButton
              size="md"
              icon={<CloseIcon />}
              aria-label="Close Menu"
              display={{ md: 'none' }}
              onClick={handleMenuClose}
              variant="ghost"
            />
          )}
          {/* </Box> */}
          {!isLoggedIn && !isOpen && (
            <IconButton
              size="md"
              icon={<HamburgerIcon />}
              aria-label="Open Menu"
              display={{ md: 'none' }}
              onClick={handleMenuOpen}
              variant="ghost"
            />
          )}

          {/* Desktop links */}
          {!isLoggedIn && (
            <HStack
              spacing={8}
              alignItems="center"
              display={{ base: 'none', md: 'flex' }}
            >
              <Text
                onClick={() => navigate('/pricing')}
                fontWeight="medium"
                color="black"
                _hover={{ color: '#006400', cursor: 'pointer' }}
              >
                Pricing
              </Text>
              <Text
                onClick={() => navigate('sign-in')}
                fontWeight="medium"
                _hover={{ color: '#006400', cursor: 'pointer' }}
              >
                Sign In
              </Text>
              <Button
                onClick={() => navigate('sign-up')}
                bgColor="#009800ff"
                color="white"
                px={5}
                fontWeight="medium"
                borderRadius="lg"
                _hover={{ bg: 'green.700' }}
              >
                Create Account
              </Button>
            </HStack>
          )}
        </Flex>
        <Box ref={menuWrapperRef} display={{ md: 'none' }}>
          {isOpen && (
            <VStack
              align="stretch"
              spacing={0}
              bg="white"
              // shadow="md"
              borderRadius="md"
              mt={2}
            >
              <MobileMenuItem
                label="Pricing"
                icon={FiDollarSign}
                action={() => navigate('/pricing')}
              />
              <MobileMenuItem
                label="Sign In"
                icon={FiLogIn}
                action={() => navigate('sign-in')}
              />
              <MobileMenuItem
                label="Create Account"
                icon={FiUserPlus}
                action={() => navigate('sign-up')}
              />
            </VStack>
          )}
        </Box>
      </Box>
      <Box h={62} />
    </>
  );
};

export default Navbar;
